export const loiteringStatusOption = [
  { label: 'Time-based', value: 'time_based' },
  { label: 'Status-based', value: 'status_based' },
  { label: 'No Penalty', value: 'no_penalty' },
]

export const listingCategoryOption = [
  { label: 'Reservation', value: 'reservation' },
  { label: 'Non-Reservation', value: 'no_reservation' },
  { label: 'Destination', value: 'destination' },
]

export const privacyOption = [
  { label: 'Public', value: 'public' },
  { label: 'Private', value: 'private' },
]

export const chargingLevelOption = [
  { label: 'Level 2', value: 'Level 2' },
  { label: 'DC', value: 'DC' },
]

export const pricingOption = [
  { label: 'Hourly', value: 'Hour' },
  { label: 'kWh', value: 'kWh' },
]

export const walletOption = [
  { label: 'Wallet', value: 'wallet' },
  { label: 'No wallet', value: 'no_wallet' },
]

export const availabilityOption = [
  { week_day: 0, hour_from: '00:00:00', hour_to: '11:59:59' },
  { week_day: 1, hour_from: '00:00:00', hour_to: '11:59:59' },
  { week_day: 2, hour_from: '00:00:00', hour_to: '11:59:59' },
  { week_day: 3, hour_from: '00:00:00', hour_to: '11:59:59' },
  { week_day: 4, hour_from: '00:00:00', hour_to: '11:59:59' },
  { week_day: 5, hour_from: '00:00:00', hour_to: '11:59:59' },
  { week_day: 6, hour_from: '00:00:00', hour_to: '11:59:59' },
]
